import { AWStageDto } from '@api/Api';
import moment from 'moment';

type DefineCanClearTimeProps = {
  stages: AWStageDto[];
  stage: AWStageDto;
};
export default function defineCanClearTime({
  stages,
  stage
}: DefineCanClearTimeProps) {
  if (!stage.deadline) return true;
  const stageDeadline = moment(stage.deadline).local();

  const stagesWithSameDate = stages.filter((it) =>
    stageDeadline.isSame(moment(it.deadline).local(), 'day')
  );

  const lastStage = stagesWithSameDate.at(-1);

  if (lastStage?.id === stage.id) return true;

  return false;
}
